import {Home} from '@/layout'

export default {
    path: '/user',
    component: Home,
    meta: {
        roles: ['user'],
        // 过滤子权限请设置true
        // childrenRoles: false
    },
    children: [
        {
            path: 'project',
            meta: {
                title: '我的项目'
            },
            component: () => import('@/page/user/project')
        },
        {
            path: 'publish/:id',
            props: true,
            component: () => import('@/page/user/project/deploy')
        },
        {
            path: 'zone/:id',
            props: true,
            component: () => import('@/page/user/zone')
        },
        {
            path: 'settings',
            meta: {
                title: '账号设置'
            },
            component: () => import('@/page/user/settings')
        },
    ]
}
